import { Settings } from '@or-sdk/settings';

import { useAuthStore } from '@/stores/auth/auth';
import { sdkApiUrl } from '@/utils/authUiRuntime';

export default new Settings({
  token: () => useAuthStore().reactiveToken as string,
  sdkUrl: sdkApiUrl,
});
